class MyDate extends Date {
    constructor(...rest) {
        super(...rest)
    }

    to24TimeString() {
        let minutes = this.getMinutes() + '';
        let seconds = this.getSeconds() + '';

        minutes = minutes.length === 1 ? `0${minutes}` : minutes;
        seconds = seconds.length === 1 ? `0${seconds}` : seconds;

        return `${this.getHours()}:${minutes}:${seconds}`
    }

    to24UTCTime() {
        let hours = this.getUTCHours() + '';
        let minutes = this.getUTCMinutes() + '';
        let seconds = this.getUTCSeconds() + '';

        minutes = minutes.length === 1 ? `0${minutes}` : minutes;
        seconds = seconds.length === 1 ? `0${seconds}` : seconds;

        return `${hours}:${minutes}:${seconds}`
    }

    to12UTCTime() {
        let intHours = parseInt(this.getUTCHours());
        let hours = intHours > 12 ? intHours - 12 : intHours + '';
        let minutes = this.getUTCMinutes() + '';
        let seconds = this.getUTCSeconds() + '';
        let ampm = intHours > 12 ? 'PM' : 'AM';

        minutes = minutes.length === 1 ? `0${minutes}` : minutes;
        seconds = seconds.length === 1 ? `0${seconds}` : seconds;

        return `${hours}:${minutes}:${seconds} ${ampm}`
    }
    

    to24String() {
        return `${this.toLocaleDateString()}, ${this.to24TimeString()}`
    }
}

window.MyDate = MyDate;
export default MyDate